<template>
  <div>
    <el-container>
      <!-------头部部分开始-------------->
      <el-header>
        <div class="left">
          <div class="title_log">
            <img alt="" src="../../static/title_logo.png" />
          </div>
          <div class="img"><img alt="" src="../../static/logo.png" /></div>
          <div class="txt">
            <p class="p1">第二十届中国国际煤炭采矿技术交流及设备展览会</p>
            <p class="p2">China Coal & Mining Expo 2023</p>
            <p class="p3">北京中国国际展览中心（新馆） 2023年10月25-28日</p>
          </div>
        </div>

        <div class="portrait">
          <div class="enlish">
            <p><span>中文</span>|<span>英文</span></p>
          </div>

          <el-col :span="25"
            ><span style="margin-right: 8px">注销</span
            ><span><i class="el-icon-caret-bottom"></i></span>
          </el-col>
        </div>
      </el-header>

      <!----------------------el-header结束---------------------------->
      <div>
        <el-dialog :visible.sync="dialogVisible" title="提示" width="20%">
          <span>你确定退出登录？</span>
          <span slot="footer" class="dialog-footer">
            <el-button size="mini" type="primary" @click="sure()"
              >确 定</el-button
            >
            <el-button size="medium" @click="dialogVisible = false"
              >取 消</el-button
            >
          </span>
        </el-dialog>
      </div>

      <!--------------------------------------------左侧栏部分开始------------------------------------------>
      <div class="container">
        <el-container>
          <el-row v-show="open" class="tac">
            <transition name="el-fade-in-linear">
              <el-col class="aisd">
                <el-menu
                  active-text-color="#209FFE"
                  background-color="white"
                  class="el-menu-vertical-demo"
                  default-active="1"
                  text-color="#006FB8"
                >
                  <el-submenu index="1">
                    <template
                      ><span slot="title" class="link">易展厅</span></template
                    >
                    <router-link to="homeIndex">
                      <el-menu-item>首页</el-menu-item>
                    </router-link>
                    <router-link to="exhiIndex">
                      <el-menu-item>展商信息</el-menu-item>
                    </router-link>
                    <router-link to="productIndex">
                      <el-menu-item>产品中心</el-menu-item>
                    </router-link>
                    <router-link to="#">
                      <el-menu-item>展商活动</el-menu-item>
                    </router-link>
                    <router-link to="exhiLive">
                      <el-menu-item>展商直播</el-menu-item>
                    </router-link>
                    <router-link to="exhi_news">
                      <el-menu-item>展商新闻</el-menu-item>
                    </router-link>
                    <router-link to="#">
                      <el-menu-item>上传展会图片</el-menu-item>
                    </router-link>
                    <router-link to="#">
                      <el-menu-item>上传展会视频</el-menu-item>
                    </router-link>
                    <router-link to="dataIndex">
                      <el-menu-item>宣传资料</el-menu-item>
                    </router-link>
                    <router-link to="mineMessage">
                      <el-menu-item>我的信息</el-menu-item>
                    </router-link>
                  </el-submenu>

                  <el-submenu index="2"
                  >
                    <template><span slot="title" class="link">展商服务</span></template>
                    <router-link to="apply">
                          <el-menu-item><i class="el-icon-setting"></i>特装申报</el-menu-item>
                    </router-link>
                    <router-link to="lintel"
                    >
                      <el-menu-item
                        ><i class="el-icon-setting"></i>标摊门楣
                      </el-menu-item>
                    </router-link>
                    <router-link to="catalogue">
                      <el-menu-item
                        ><i class="el-icon-setting"></i>会刊信息
                      </el-menu-item>
                    </router-link>
                    <router-link to="greenPlant">
                      <el-menu-item
                        ><i class="el-icon-setting"></i>家具/绿植
                      </el-menu-item>
                    </router-link>
                    <router-link to="card">
                      <el-menu-item
                        ><i class="el-icon-setting"></i>参展商证
                      </el-menu-item>
                    </router-link>
                  </el-submenu>

                  <el-submenu index="3">
                    <template
                      ><span slot="title" class="link">观众邀请</span></template
                    >
                    <router-link to="wxInvite">
                      <el-menu-item
                        ><i class="el-icon-setting"></i>微信邀请
                      </el-menu-item>
                    </router-link>
                    <router-link to="emailInvite">
                      <el-menu-item
                        ><i class="el-icon-setting"></i>邮件邀请
                      </el-menu-item>
                    </router-link>
                    <router-link to="pdfInvite">
                      <el-menu-item
                        ><i class="el-icon-setting"></i>PDF邀请
                      </el-menu-item>
                    </router-link>
                    <router-link to="groupInvite">
                      <el-menu-item
                        ><i class="el-icon-setting"></i>团体邀请
                      </el-menu-item>
                    </router-link>
                  </el-submenu>

                  <router-link to="Download">
                    <el-menu-item index="4"
                      ><i class="el-icon-setting"></i>下载中心
                    </el-menu-item>
                  </router-link>

                  <router-link to="Connection"
                  >
                    <el-menu-item index="5"
                      ><i class="el-icon-setting"></i>联系我们
                    </el-menu-item>
                  </router-link>

                  <router-link to="verifyPassword"
                  >
                    <el-menu-item index="6"
                      ><i class="el-icon-setting"></i>修改密码
                    </el-menu-item>
                  </router-link>
                </el-menu>
              </el-col>
            </transition>
          </el-row>
          <!-------左侧栏部分结束-------------->

          <!-------右侧部分开始-------------->
          <el-main class="elmain" style="overflow-y: hidden">
            <router-view />
          </el-main>
          <!-------右侧部分结束-------------->
        </el-container>
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      open: true,
      dialogVisible: false,
      fullscreen: false,
    };
  },
  methods: {
    stateSwitch() {
      this.open = !this.open;
    },
    sure() {
      sessionStorage.clear();
      this.dialogVisible = !this.dialogVisible;
      this.$router.replace("/Login");
    },

    handleFullScreen() {
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },
  },
};
</script>
<style scoped>
* {
  margin: 0px;
  padding: 0px;
  text-decoration: none;
}
body,
html {
  height: 100%;
  width: 100%;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-image: url("../../static/backImg.png");
  width: 100%;
  box-sizing: border-box;
  padding-right: 20px;
  height: 74px !important;
}

.title_log img {
  height: 62px;
}
.link {
  font-size: 18px;
  font-weight: 500;
  color: #006fb8;
}
.img img {
  height: 62px;
  margin: 0 10px 0 20px;
}

.enlish {
  margin-right: 20px;
  align-items: center;
}

.enlish p {
  display: block;
  line-height: 74px;
  color: white;
  font-size: 14px;
}

.enlish p span {
  margin-right: 5px;
  cursor: pointer;
}

.enlish p :last-child {
  margin-left: 5px;
}

.el-menu {
  border: none;
}

.el-menu-item {
  /* color: #f0f0f0; */

  color: #666666 !important;
  font-weight: 400px !important;
}

.el-menu-item:hover {
  color: #006FB8 !important;
  /* background:; */
}

.el-main {
  background-color: #F0F2F5;;
  color: #333;
}

.el-row >>> .el-col-24 {
  width: 220px;
  background: white !important;

  background-color: white;
}

.left {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  margin-left: 50px;
  color: white;
}

.el-header .title {
  font-size: 21px;
  margin-left: 30px;
}

.right {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 25px;
  margin-right: 50px;
  color: white;
}

.icon1 i {
  margin-right: 30px;
}

.portrait {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.portrait img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 30px;
}

.el-dropdown {
  position: relative;
  top: -2px;
}

.el-dropdown-link {
  cursor: pointer;
  color: white;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}
</style>
